import searchUrlMap from './searchUrlMap';

const dateManipulation = require('@ott/utility-date');

function getServiceClass(serviceClass) {
  switch (serviceClass) {
    case 'premium':
      return 'W';
    case 'business':
      return 'B';
    case 'first':
      return 'F';
    default:
      return 'E';
  }
}

function checkRT(flights) {
  if (flights.length === 1 && flights[0].dates.toDate && flights[0].dates.fromDate) {
    return true;
  }

  if (flights.length !== 2) {
    return false;
  }

  if (flights[0].from.code !== flights[1].to.code) {
    return false;
  }

  if (flights[0].to.code !== flights[1].from.code) {
    return false;
  }

  return true;
}

export default function getFlightsSearchQueryParams(formData) {
  const { serviceClass: formServiceClass, flights } = formData;

  const serviceClass = getServiceClass(formServiceClass);

  const { adultsCount, childrenAges } = formData;

  const query = {
    [searchUrlMap.serviceClass]: serviceClass,
    [searchUrlMap.adultsCount]: adultsCount,
  };

  if (childrenAges.length > 0) {
    query[searchUrlMap.childrenAges] = childrenAges.join('_');
  }

  let route = '';

  const isRT = checkRT(flights);

  flights.forEach((flight, i) => {
    const toDate = dateManipulation.formatShort(flight.dates.toDate, '');

    const { to, from } = flight;

    if (isRT) {
      if (flights.length === 1) {
        const fromDate = dateManipulation.formatShort(flight.dates.fromDate, '');
        route += `${toDate}${from.code}${to.code}${fromDate}`;
      } else if (flights.length === 2 && i === 0) {
        route += `${toDate}${from.code}${to.code}`;
      } else {
        route += toDate;
      }
    } else {
      route += `${toDate}${from.code}${to.code}`;
    }
  });

  return {
    route,
    query,
  };
}
